<app-slide
  [mechanicalDisplacement]="!isMobile"
  [activated]="activeSlidePromos"
  [quantityOfItems]="promos?.length"
  [slideWidth]="slideWidth">
  <ng-container content>
    <div *ngFor="let promo of promos; index as id"
      class="slidePromo__item" 
      [style.width]="slideWidth + 'px'"
      [id]="'slidePromo__item__' + index + '-' + id"
      (click)="selectPromo(promo)">
      <app-ds-generic-card
        [space]="genericCardSpaces.XXXSCompact"
        [image]="{
          IsEnabled: true,
          Src: promo.image_url,
          SrcFallback: fallbackImg,
          DiscountLabel: activeDiscount(promo) ? ('HOTELS_MODULE.RESULT_HOTELS.OFF' | transloco: { percentage: promo.discount_percent }) : null,
        }">
        <div class="slidePromo__content-body">
          <div class="slidePromo__description" [class.is-rappi-card]="isRappiCard" [ngClass]="{'no-radius': !!promo?.cashback_percent}">
            <div class="slidePromo__description-left" [class.price-is-activated]="activeSubtitle(promo) || activePrice(promo)">
              <div class="slidePromo__description-subtitle">
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [fontFamily]="fontFamily.Regular"
                  [color]="fontColor.Primary"
                  [text]="promo.sub_title"
                  [ellipsis]="true">
                </app-ds-typography>
              </div>
              <div class="slidePromo__description-title">
                <app-ds-typography
                  [size]="fontSize.XXS"
                  [fontFamily]="fontFamily.SemiBold"
                  [color]="fontColor.Primary"
                  [text]="promo.title"
                  [ellipsis]="false">
                </app-ds-typography>
              </div>
            </div>
            @if (activeSubtitle(promo) || activePrice(promo)) {
              <div class="slidePromo__description-right">
                @if (activeSubtitle(promo)) {
                  <div class="slidePromo__description-subtitle">
                    <app-ds-typography
                      [size]="fontSize.XXXS"
                      [fontFamily]="fontFamily.Regular"
                      [color]="fontColor.Primary"
                      [text]="'HOME_MODULE.PRICE_FROM'| transloco">
                    </app-ds-typography>
                  </div>
                }
                @if (activePrice(promo)) {
                  <div class="slidePromo__description-price">
                    <app-ds-typography
                      [size]="fontSize.XXS"
                      [fontFamily]="fontFamily.SemiBold"
                      [color]="fontColor.Primary"
                      [text]="promo.price_from | currencyFormat: promo.currency">
                    </app-ds-typography>
                  </div>
                }
                @if (activeBeforePrice(promo)) {
                  <div class="slidePromo__description-price-decoration">
                    <app-ds-typography
                      [size]="fontSize.XXXS"
                      [fontFamily]="fontFamily.Regular"
                      [color]="fontColor.Primary"
                      [textDecoration]="'line-through'"
                      [text]="promo.price_from_before_discount | currencyFormat: promo.currency : true">
                    </app-ds-typography>
                  </div>
                }
              </div>
            }
          </div>
          @if (promo.sub_text) {
            <div class="slidePromo__description-sub-text">
              <app-ds-typography
                [size]="fontSize.XXXS"
                [fontFamily]="fontFamily.Regular"
                [color]="fontColor.Secondary"
                [text]="promo.sub_text"
                [ellipsis]="true">
              </app-ds-typography>
            </div>
          }
          <app-benefit-cashback
            [benefitViewType]="benefitViewType"
            [productReference]="promo.product_reference"
            [totalPrice]="promo.price_from"
            [currencyCode]="promo.currency"
            [staticCmsPercentage]="promo.cashback_percent">
          </app-benefit-cashback>
          <app-benefits-installments
            [totalPrice]="promo.price_from"
            [currencyCode]="promo.currency"
            [searchBy]="searchByDeeplink(promo?.deeplink)"
            [productReference]="promo.product_reference"
            [isCMS]="true"
            (viewFinancialPartners)="toggleFinancialPartners($event, searchByDeeplink(promo?.deeplink))">
          </app-benefits-installments>
        </div>
      </app-ds-generic-card>
    </div>
  </ng-container>
</app-slide>